var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"export-format"},[_c('ctrl-switch-values',{attrs:{"values":_vm.values,"selected":_vm.format},on:{"change":_vm.updateExportFormat}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }